import { OnInit, Inject, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FilterService } from '../../../services/filter.service';
import { FilterCompleteService } from '../../../filter-complete/filter-complete';
import { PhysicianFilter } from '../../../model/physician-Filter';


export class StudyReportPhysicianSignatureDialogRequest {
  public PhysicianIdSignatureOne?: number;
  public PhysicianIdSignatureTwo?: number;
  public PhysicianIdSignatureThree?: number;
  public PhysicianIdSignatureFour?: number;
  public PhysicianIdSignatureFive?: number;
  public PhysicianIdSignatureSix?: number;
}

export class StudyReportPhysicianSignatureDialogResult {
  public PhysicianSignatureOne?: PhysicianFilter;
  public PhysicianSignatureTwo?: PhysicianFilter;
  public PhysicianSignatureThree?: PhysicianFilter;
  public PhysicianSignatureFour?: PhysicianFilter;
  public PhysicianSignatureFive?: PhysicianFilter;
  public PhysicianSignatureSix?: PhysicianFilter;
}


@Component({
  selector: 'study-report-physician-signature-dialog',
  templateUrl: 'study-report-physician-signature-dialog.component.html',
  styleUrls: ['./study-report-physician-signature-dialog.component.css']
})
export class StudyReportPhysicianSignatureDialogComponent implements OnInit {

  loading: boolean;
  filterCompletePhysiciansOne: FilterCompleteService<PhysicianFilter>;
  filterCompletePhysiciansTwo: FilterCompleteService<PhysicianFilter>;
  filterCompletePhysiciansThree: FilterCompleteService<PhysicianFilter>;
  filterCompletePhysiciansFour: FilterCompleteService<PhysicianFilter>;
  filterCompletePhysiciansFive: FilterCompleteService<PhysicianFilter>;
  filterCompletePhysiciansSix: FilterCompleteService<PhysicianFilter>;

  form: FormGroup;

  constructor(private filterService: FilterService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<StudyReportPhysicianSignatureDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: StudyReportPhysicianSignatureDialogRequest) {

    this.form = this.formBuilder.group({
      PhysicianSignatureOne: [null]
      , PhysicianSignatureTwo: [null]
      , PhysicianSignatureThree: [null]
      , PhysicianSignatureFour: [null]
      , PhysicianSignatureFive: [null]
      , PhysicianSignatureSix: [null]
    });

    this.filterCompletePhysiciansOne = new FilterCompleteService<PhysicianFilter>([], this.form.controls.PhysicianSignatureOne);
    this.filterCompletePhysiciansTwo = new FilterCompleteService<PhysicianFilter>([], this.form.controls.PhysicianSignatureTwo);
    this.filterCompletePhysiciansThree = new FilterCompleteService<PhysicianFilter>([], this.form.controls.PhysicianSignatureThree);
    this.filterCompletePhysiciansFour = new FilterCompleteService<PhysicianFilter>([], this.form.controls.PhysicianSignatureFour);
    this.filterCompletePhysiciansFive = new FilterCompleteService<PhysicianFilter>([], this.form.controls.PhysicianSignatureFive);
    this.filterCompletePhysiciansSix = new FilterCompleteService<PhysicianFilter>([], this.form.controls.PhysicianSignatureSix);
  }

  get filteredPhysiciansOptionsOne() { return this.filterCompletePhysiciansOne ? this.filterCompletePhysiciansOne.filteredOptions : []; }
  get filteredPhysiciansOptionsTwo() { return this.filterCompletePhysiciansTwo ? this.filterCompletePhysiciansTwo.filteredOptions : []; }
  get filteredPhysiciansOptionsThree() { return this.filterCompletePhysiciansThree ? this.filterCompletePhysiciansThree.filteredOptions : []; }
  get filteredPhysiciansOptionsFour() { return this.filterCompletePhysiciansFour ? this.filterCompletePhysiciansFour.filteredOptions : []; }
  get filteredPhysiciansOptionsFive() { return this.filterCompletePhysiciansFive ? this.filterCompletePhysiciansFive.filteredOptions : []; }
  get filteredPhysiciansOptionsSix() { return this.filterCompletePhysiciansSix ? this.filterCompletePhysiciansSix.filteredOptions : []; }

  get f() { return this.form.controls; }

  async ngOnInit() {
    try {
      this.loading = true;
      const physiciansFilter = await this.filterService.getPhysiciansFilter();
      this.filterCompletePhysiciansOne = new FilterCompleteService<PhysicianFilter>(physiciansFilter, this.form.controls.PhysicianSignatureOne);
      this.filterCompletePhysiciansTwo = new FilterCompleteService<PhysicianFilter>(physiciansFilter, this.form.controls.PhysicianSignatureTwo);
      this.filterCompletePhysiciansThree = new FilterCompleteService<PhysicianFilter>(physiciansFilter, this.form.controls.PhysicianSignatureThree);
      this.filterCompletePhysiciansFour = new FilterCompleteService<PhysicianFilter>(physiciansFilter, this.form.controls.PhysicianSignatureFour);
      this.filterCompletePhysiciansFive = new FilterCompleteService<PhysicianFilter>(physiciansFilter, this.form.controls.PhysicianSignatureFive);
      this.filterCompletePhysiciansSix = new FilterCompleteService<PhysicianFilter>(physiciansFilter, this.form.controls.PhysicianSignatureSix);

      const one = this.data.PhysicianIdSignatureOne != null ? physiciansFilter.find(x => x.Id == this.data.PhysicianIdSignatureOne) : null;
      const two = this.data.PhysicianIdSignatureTwo != null ? physiciansFilter.find(x => x.Id == this.data.PhysicianIdSignatureTwo) : null;
      const three = this.data.PhysicianIdSignatureThree != null ? physiciansFilter.find(x => x.Id == this.data.PhysicianIdSignatureThree) : null;
      const four = this.data.PhysicianIdSignatureFour != null ? physiciansFilter.find(x => x.Id == this.data.PhysicianIdSignatureFour) : null;
      const five = this.data.PhysicianIdSignatureFive != null ? physiciansFilter.find(x => x.Id == this.data.PhysicianIdSignatureFive) : null;
      const six = this.data.PhysicianIdSignatureSix != null ? physiciansFilter.find(x => x.Id == this.data.PhysicianIdSignatureSix) : null;

      this.form.patchValue({
        PhysicianSignatureOne: one
        , PhysicianSignatureTwo: two
        , PhysicianSignatureThree: three
        , PhysicianSignatureFour: four
        , PhysicianSignatureFive: five
        , PhysicianSignatureSix: six
      });

    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Firma de médicos');
    } finally {
      this.loading = false;
    }
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    this.dialogRef.close(<StudyReportPhysicianSignatureDialogResult>this.form.getRawValue());
  }
}